import { Fragment } from "react";
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import ProductStockMovements from "./ProductStockMovements";

const ProductStockMovementsWrapper = () => {
    const defaultFilters = {};

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <ProductStockMovements />
            </FiltersProvider>
        </Fragment>
    );
};

export default ProductStockMovementsWrapper;